export default __webpack_public_path__ + "static/media/caseSlide4.e94a19dd.png";